module.exports = __webpack_public_path__ + "2332a8d8098dc05fa92a4376093c92c6.svg";